import React, { useState } from 'react';
import { Row, Col, Form, Button, Select, Table } from 'antd';
import useFranchiseAndBranchStatus from '../../../../hooks/useFranchiseAndBranchStatus';
import classes from './../../Integraciones/Integraciones.module.css';
import InfoBar from 'components/molecules/Integraciones/InfoBar/InfoBar';
import X from '../SVG/X';
import No from '../SVG/No';
import Check from '../SVG/Check';
import DesmatchearModal from './../DesmatchearModal';
import Matchear from '../Matchear';
import { useHistory } from 'react-router-dom';

const SucursalesTab = () => {
    const brandsHook = useFranchiseAndBranchStatus();
    const [modalDesmatchear, setModalDesmatchear] = useState(false);
    const [form] = Form.useForm();

    const pageChangeHandler = (page) => {
        window.scrollTo({ top: 100, behavior: 'smooth' });
        brandsHook.getBrandsList(page);
    };

    const history = useHistory();

    const handleCancelDesmatchear = () => {
        setModalDesmatchear(false);
    };

    const [matchearVisible, setMatchearVisible] = useState(false);

    const openMatchear = () => {
        history.push('/administrar/matchearSucursal');
    };

    const columns = [
        {
            title: 'ID Externo',
            dataIndex: 'id',
            key: 'id',
            align: 'flex-start',
            width: '15%',
        },
        {
            title: 'Franquicia',
            dataIndex: 'franchise',
            key: 'franchise',
            align: 'flex-start',
            width: '15%',
        },
        {
            title: 'Sucursal',
            dataIndex: 'branch',
            key: 'branch',
            align: 'flex-start',
            width: '15%',
        },
        {
            title: 'Sincronizado',
            dataIndex: 'synchronized',
            key: 'synchronized',
            align: 'left',
            width: '15%',
        },
        {
            title: 'Matcheado',
            dataIndex: 'matched',
            key: 'matched',
            render: (text) => {
                if (text === 'Si') {
                    return <No />;
                } else if (text === 'No') {
                    return <Check />;
                }
                return text;
            },
            align: 'center',
            width: '12%',
        },
        {
            title: 'Acción',
            dataIndex: 'action',
            key: 'action',
            render: (text) => {
                if (text === 'Acción 1') {
                    return {
                        props: {
                            className: classes.BackgroundTabla1,
                            onClick: () => setModalDesmatchear(true),
                        },
                        children: (
                            <div className={classes.TablaAccionDesmatchear}>
                                <span style={{ marginRight: '10px' }}>
                                    Desmatchear
                                </span>
                                <No />
                            </div>
                        ),
                    };
                } else if (text === 'Acción 2') {
                    return {
                        props: {
                            className: classes.BackgroundTabla2,
                            onClick: () => openMatchear(true),
                        },
                        children: (
                            <div className={classes.TablaAccionMatchear}>
                                <span
                                    style={{
                                        marginRight: '10px',
                                    }}>
                                    Matchear
                                </span>
                                <Check />
                            </div>
                        ),
                    };
                }
                return text;
            },
            align: 'center',
            width: '5%',
        },
    ];

    // Datos de prueba
    const dataSource = [
        {
            id: 87,
            franchise: 'Monchis Store',
            branch: 'Shopping del sol',
            synchronized: (
                <div style={{ textAlign: 'left' }}>
                    05-09-2023 23:51:26
                    <br />
                    Por: Ceci Falcón
                </div>
            ),
            matched: 'No',
            action: 'Acción 1',
        },
        {
            id: 88,
            franchise: 'Elias Store',
            branch: 'Sucursal 2',
            synchronized: (
                <div style={{ textAlign: 'left' }}>
                    05-09-2023 23:51:26
                    <br />
                    Por: Ceci Falcón
                </div>
            ),
            matched: 'Si',
            action: 'Acción 2',
        },
    ];

    const fakeBarData = [
        {
            id: '1',
            label: 'Productos',
            value: '0',
        },
        {
            id: '2',
            label: 'Sin Matcheo',
            value: '0',
        },
        {
            id: '3',
            label: 'Matcheados',
            value: '0',
        },
    ];

    return (
        <div className="mt36">
            <Form form={form} layout="vertical">
                <Row gutter={12} align="middle">
                    <Col span={4}>
                        <Form.Item label="ID externo de sucursal" name="branch">
                            <Select
                                maxTagCount="responsive"
                                mode="multiple"
                                optionFilterProp="children"
                                placeholder="Ingresá ID externo"></Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item label="Franquicia" name="franchise">
                            <Select
                                allowClear
                                optionFilterProp="children"
                                placeholder="Seleccioná una franquicia"></Select>
                        </Form.Item>
                    </Col>

                    <Col span={2}>
                        <Form.Item label="Sucursal" name="refineSearch">
                            <Select
                                allowClear
                                optionFilterProp="children"
                                placeholder="Todas"></Select>
                        </Form.Item>
                    </Col>

                    <Col span={2}>
                        <Button type="primary" htmlType="button">
                            Buscar
                        </Button>
                    </Col>
                    <Col className={classes.botonDescargar}>
                        <Button htmlType="button">
                            <X />
                            <span
                                style={{
                                    marginLeft: '8px',
                                }}>
                                Descargar Excel
                            </span>
                        </Button>
                    </Col>
                </Row>
            </Form>

            <InfoBar data={fakeBarData} />

            <Row span={24} className="mt32">
                <Table
                    className={classes.customTableHeader2 + ' ' + 'w100'}
                    columns={columns}
                    dataSource={dataSource}
                    rowKey="id"
                    pagination={{
                        pageSize: 15,
                        showSizeChanger: false,
                        total: dataSource.length,
                        current: 1,
                        onChange: pageChangeHandler,
                    }}
                />
            </Row>
            {console.log(modalDesmatchear)}
            <DesmatchearModal
                modalDesmatchear={modalDesmatchear}
                handleCancelDesmatchear={handleCancelDesmatchear}
            />
            {matchearVisible && (
                <Matchear onClose={() => setMatchearVisible(false)} />
            )}
        </div>
    );
};

export default SucursalesTab;
